import { useEffect, useState } from "react";

const WS_BASE = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");

export const useLiveTicks = symbol => {
  const [tick, setTick] = useState(null);
  useEffect(() => {
    if (!symbol) return undefined;
    let ws, retry, closed = false, delay = 1000;
    const open = () => {
      ws = new WebSocket(`${WS_BASE}/api/ws/live/${encodeURIComponent(symbol)}`);
      ws.onmessage = e => { const d = JSON.parse(e.data); if (d.ltp) delay = 1000; setTick(t => d.ltp ? d : { ...t, error: d.error }); };
      ws.onclose = () => { if (!closed) { retry = setTimeout(open, delay); delay = Math.min(delay * 2, 30000); } };
    };
    setTick(null); open();
    return () => { closed = true; clearTimeout(retry); ws.close(); };
  }, [symbol]);
  return tick?.symbol === symbol ? tick : null;
};
